import { connect } from 'react-redux';
import TambahRombel from '../../views/Settings/TambahRombel.view';
import {
  getUserGroups, getSchoolUnitsOptions, getParamPerwakilan,
  getPrmStaffMaster, getParamOptionsAcademics
} from '../../states/thunks/options.thunk';
import { listBlockUnits, editRombels, saveRombels, listMasterPositions } from '../../states/thunks/academics.thunk';

function mapStateToProps(state) {
  return {
    classes: state.options.classes,
    levels: state.options.levels,
    user: state.user || {},
  };
}

function mapDispatchToProps(dispatch) {
  return {
    handleListBlockUnits: (payload, goback) => dispatch(listBlockUnits(payload, goback)),
    getPrmStaffMasterOptions: payload => dispatch(getPrmStaffMaster(payload)),
    getUserGroups: payload => dispatch(getUserGroups(payload)),
    getSchoolUnitsOptions: payload => dispatch(getSchoolUnitsOptions(payload)),
    getParamPerwakilan: payload => dispatch(getParamPerwakilan(payload)),
    handleListMasterPositions: (payload, goback) => dispatch(listMasterPositions(payload, goback)),
    handleSaveRombels: (payload, goback) => dispatch(saveRombels(payload, goback)),
    handleEditRombels: (payload, goback) => dispatch(editRombels(payload, goback)),
    getParamOptionsAcademics: (payload, type) => dispatch(getParamOptionsAcademics(payload, type)),

  };
}

export default connect(mapStateToProps, mapDispatchToProps)(TambahRombel);
